import { render, staticRenderFns } from "./dashboardBagagiste.vue?vue&type=template&id=fdfa6e2a&scoped=true"
import script from "./dashboardBagagiste.vue?vue&type=script&lang=js"
export * from "./dashboardBagagiste.vue?vue&type=script&lang=js"
import style0 from "./dashboardBagagiste.vue?vue&type=style&index=0&id=fdfa6e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfa6e2a",
  null
  
)

export default component.exports